import React, { useEffect } from "react";
import { Routes, Route, useLocation, BrowserRouter } from "react-router-dom";
import Header from "../components/common/headers/headers.jsx";
import Footer from "../components/common/footer/footer.jsx";
import { selectHamburgerState } from "../redux/features/homeSlice.js";
import { useSelector } from "react-redux";
import { Dashboard } from "../pages/dashboard.jsx";
import TermsAndConditions from "../pages/tnc.jsx";
import PrizeRules from "../pages/prizeRules.jsx";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const Layout = () => {
  const isHamburger = useSelector(selectHamburgerState);

  return (
    <div className={`App ${isHamburger ? "overflow-hidden " : ""}`}>
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        {isHamburger &&
        <div className="overlay-on-mobile"></div>}
        <div className="mainContainer">
          <Routes>

            <Route path="/" element={<Dashboard />} />
            <Route path="/prize-rules" element={<PrizeRules />} />
            <Route path="/terms-n-conditions" element={<TermsAndConditions/>} />

          </Routes>
        </div>
        <Footer />
      </BrowserRouter>
    </div>
  );
};

export default Layout;
